import { Layout } from "@/components/layout/Layout";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { getStrapiEntity } from "@/utils/strapi";
import { routes } from "@/routes/routes";
import { queryOneWay } from "@/strapiQuery/oneWay";
import { OneWayContent } from "@/components/pages/oneWay/OneWay";
import { VehicleType } from "@/components/common/searchBlock/children/vehicleTypeSelection/VehicleTypeSelection";
import { ReviewsConst } from "@/components/common/reviewsBlock/ReviewsBlock";
import { queryReviewsConst } from "@/strapiQuery/queryReviewsConst";

export const getStaticProps = async (ctx: LoadI18nMessagesProps) => {
  const layoutPromise = getStrapiEntity<Layout>("layout", "");
  const reviewsConst = await getStrapiEntity<ReviewsConst>(
    "reviews-const",
    queryReviewsConst
  );

  const oneWayContentPromise = getStrapiEntity<OneWayContent>(
    "one-way-car",
    queryOneWay
  );

  const [layout, oneWayContent] = await Promise.all([
    layoutPromise,
    oneWayContentPromise,
  ]);

  const intlMessages = loadIntlMessages(ctx);

  return {
    props: {
      layout,
      reviewsConst,
      ...oneWayContent,
      vehicleType: VehicleType.CAR,
      intlMessages,
      defaultCanonicalRoute: routes.oneWayCar,
    },
    revalidate: 10,
  };
};

export { OneWay as default } from "@/components/pages/oneWay/OneWay";
